import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

export default function CustomLesson({ theme, ...props }) {
  return (
    <svg
      aria-labelledby={props.ariaTags.labelledBy}
      aria-hidden={props.ariaTags.hidden}
      className={cx(theme.container, theme[props.svg], props.className)}
      shapeRendering="geometricPrecision"
      tabIndex={props.tabIndex}
      vectorEffect="non-scaling-stroke"
      width="28"
      height="23"
      viewBox="0 0 28 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {props.title ? (
        <title id={props.ariaTags.labelledBy} lang="en">
          {props.title}
        </title>
      ) : null}
      <g className={theme.stroke} fill="none" fillRule="evenodd">
        <path
          d="M16.0781 14.3084L23.0371 21.3338L27.0404 22.0426L26.3289 17.9691L19.4794 11.0449"
          stroke="#7F2BB8"
          strokeWidth="1.5"
          strokeMiterlimit="10"
        />
        <path
          d="M15.9671 7.46213L11.9325 3.38086L8.59375 6.70663L12.6675 10.8113"
          stroke="#7F2BB8"
          strokeWidth="1.5"
          strokeMiterlimit="10"
        />
        <path
          d="M11.9376 3.37939L9.73265 1.14404C9.61747 1.02556 9.47955 0.931367 9.32709 0.867032C9.17464 0.802698 9.01075 0.769531 8.84518 0.769531C8.67961 0.769531 8.51572 0.802698 8.36327 0.867032C8.21081 0.931367 8.07289 1.02556 7.95771 1.14404L6.3939 2.70178C6.16116 2.94389 6.03125 3.26616 6.03125 3.60137C6.03125 3.93658 6.16116 4.25885 6.3939 4.50096L8.55979 6.68958L11.9376 3.37939Z"
          stroke="#7F2BB8"
          strokeWidth="1.5"
          strokeMiterlimit="10"
        />
        <path
          d="M9.22496 16.6674C10.6402 17.3528 11.5707 19.3623 9.72539 21.1615C7.8801 22.9607 4.5101 21.7223 1.77344 20.9746C3.21826 19.8913 4.55377 18.6705 5.76113 17.3295C6.15853 16.8179 6.72971 16.4683 7.36746 16.3464C8.00522 16.2245 8.66569 16.3387 9.22496 16.6674Z"
          stroke="#7F2BB8"
          strokeWidth="1.5"
          strokeMiterlimit="10"
        />
        <path
          d="M10.642 18.0379C15.2787 15.3118 20.0248 10.8645 25.6389 3.13031C26.7258 1.65046 26.0689 1.05854 26.0689 1.05854C26.0689 1.05854 25.4669 0.404277 23.9813 1.47912C16.217 7.11034 11.7523 11.8069 9.02344 16.4178"
          stroke="#7F2BB8"
          strokeWidth="1.5"
          strokeMiterlimit="10"
        />
      </g>
    </svg>
  )
}

CustomLesson.propTypes = {
  ariaTags: PropTypes.object.isRequired,
  svg: PropTypes.string.isRequired,
  theme: PropTypes.object.isRequired,
  className: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
}
